import PropTypes from 'prop-types';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import {Modal} from '@/components/atoms';
import {MODAL_TYPE} from '@/utils/constants/globalStyle';
import {useEditRackModal} from '@/hooks/useEditRackModal';
import RackModalForm from './RackModalForm';
import './addRackModal.scss';

const EditRackModal = ({rack, onClose, onSaved}) => {
  const hook = useEditRackModal({rack, onSuccess: onSaved || onClose});
  const {
    isSaving,
    isDeleting,
    showDeleteConfirm,
    canSave,
    publishError,
    handleSave,
    handleDeleteRequest,
    handleDeleteCancel,
    handleDeleteConfirm
  } = hook;

  const isBusy = isSaving || isDeleting;

  const handleClose = () => {
    if (!isBusy) onClose();
  };

  if (showDeleteConfirm) {
    return (
      <Modal
        id='delete-rack-confirm'
        type={MODAL_TYPE.SMALL}
        showModal
        title='Delete Rack'
        isDark
        hideCloseButton
        className='addRackModal'
        primaryButtonText={isDeleting ? 'Deleting...' : 'Confirm Delete'}
        secondaryButtonText='Cancel'
        primaryButtonProps={{'aria-label': 'Confirm Delete'}}
        secondaryButtonProps={{'aria-label': 'Cancel'}}
        showSecondaryButton
        primaryButtonDisabled={isDeleting}
        secondaryButtonDisabled={isDeleting}
        onCloseModal={handleDeleteCancel}
        onClickSecondaryButton={handleDeleteCancel}
        onClickPrimaryButton={handleDeleteConfirm}
        content={
          <div className='addRackContent'>
            <p>
              Are you sure you want to delete rack &quot;{rack.displayName}
              &quot; ({rack.rackId})? This action cannot be undone.
            </p>
            {publishError && (
              <p className='addRackError' role='alert'>
                {publishError}
              </p>
            )}
          </div>
        }
      />
    );
  }

  return (
    <Modal
      id='edit-rack'
      type={MODAL_TYPE.SMALL}
      showModal
      title='Edit Rack'
      isDark
      hideCloseButton
      className='addRackModal'
      primaryButtonText={isSaving ? 'Saving...' : 'Done'}
      secondaryButtonText='Cancel'
      primaryButtonProps={{'aria-label': 'Done'}}
      secondaryButtonProps={{'aria-label': 'Cancel'}}
      showSecondaryButton
      secondaryButtonDisabled={isBusy}
      primaryButtonDisabled={!canSave}
      onCloseModal={handleClose}
      onClickSecondaryButton={handleClose}
      onClickPrimaryButton={handleSave}
      content={
        <RackModalForm
          idPrefix='edit-rack'
          isBusy={isBusy}
          readOnlyFields={['rackId']}
          imagesLabel='Images'
          acceptHint='(only .jpg,.png)'
          {...hook}>
          <div className='editRackFooterActions'>
            <button
              type='button'
              className='editRackDeleteButton'
              disabled={isBusy}
              onClick={handleDeleteRequest}>
              <DeleteOutlineIcon />
              Delete Rack
            </button>
          </div>
        </RackModalForm>
      }
    />
  );
};

EditRackModal.propTypes = {
  rack: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
  onSaved: PropTypes.func
};

export default EditRackModal;
